import React from "react";

function CogWheelIcon({
  className,
  style,
}: {
  className?: string;
  style?: object;
}) {
  return (
    <svg className={className} style={style} viewBox="0 0 54.11 53.99">
      <path
        d="M27.12,16.99c-5.53,0-10,4.48-10,10s4.48,10,10,10c5.53,0,10-4.48,10-10S32.65,16.99,27.12,16.99z M27.12,35
		c-4.41,0-8-3.59-8-8s3.59-8,8-8c4.41,0,8,3.59,8,8S31.53,35,27.12,35z"
      />
      <path
        d="M54.11,33.44l0-13.08l-6.84,0c-0.23-0.67-0.49-1.32-0.77-1.95l5.09-4.51L42.9,4.11l-5.23,4.64
		c-1.29-0.74-2.67-1.35-4.11-1.81V0H20.48v7.12c-1.07,0.36-2.1,0.8-3.09,1.33L12.34,3.5l-9.15,9.35l5.11,5
		c-0.36,0.74-0.69,1.51-0.96,2.29L0.27,20L0,33.08l7,0.14c0.41,1.39,0.96,2.72,1.63,3.97l-4.72,5l9.52,8.98l4.66-4.94
		c0.84,0.41,1.71,0.77,2.61,1.07l0.01,6.68l13.08-0.01l-0.01-6.65c0.92-0.3,1.81-0.67,2.67-1.09l4.53,4.79l9.51-8.99l-4.59-4.86
		c0.64-1.19,1.17-2.44,1.57-3.75L54.11,33.44z M45.92,31.43c-0.49,2.18-1.36,4.21-2.52,6.03l1.42,1.51l0.01,0.01c0,0,0,0,0,0
		l2.82,2.99l-6.6,6.24l-2.8-2.96c0,0,0,0,0,0l-1.4-1.48l-0.03-0.03c0,0-0.01,0.01-0.01,0.01l-0.98,0.57
		c-0.82,0.41-1.66,0.77-2.54,1.06l-1.52,0.35v0.08l0,2.06c0,0,0,0,0,0l0,4.11l-9.08,0.01l0-2.82h0v-1.31v-2.06v-0.05
		c0,0-0.01,0-0.01,0l-1.31-0.31c-1.3-0.42-2.54-0.99-3.7-1.67l-1.4,1.48l-0.06,0.06c0,0,0,0,0,0l-2.87,3.04l-6.61-6.23l2.86-3.04
		c0,0,0,0,0,0l0.1-0.11l1.42-1.5c-1.2-1.89-2.09-3.99-2.58-6.24L6.5,31.2l-0.29,0c0,0,0,0.01,0,0.01l-4.18-0.08l0.19-9.08l4.17,0.08
		c0,0,0,0,0,0l0.34,0.01l2.05,0.03c0.45-1.66,1.12-3.24,1.97-4.69L9.3,16.04l-1.32-1.29l0,0l-1.96-1.92l6.35-6.49l2.98,2.92
		c0,0,0,0,0,0l0.26,0.25l1.47,1.44c1.65-1.05,3.48-1.84,5.42-2.34l-0.01-2.06l0-0.37c0,0,0,0-0.01,0V2h9.08v3.95l0,0.47l0.01,2.07
		c2.29,0.53,4.43,1.46,6.32,2.73l1.53-1.36l0.18-0.16c0,0,0,0,0,0l3.13-2.77l6.03,6.79l-3.12,2.77c0,0,0,0,0,0l-0.09,0.08
		l-1.52,1.35c0.76,1.38,1.35,2.88,1.75,4.44l2.06,0l1.65,0v0l2.62,0l0,9.08l-3.99,0c0,0,0,0,0-0.01h-0.13L45.92,31.43z"
      />
    </svg>
  );
}

export { CogWheelIcon };
